import { cloneDeep } from "lodash";
import getSpecific from '../api/getSpecific';

function settingHideProcessShcema(id, shcema) {

    let processName = id;

    let columnNameArray = getColumnNameArrayPerProcess(processName);

    let processSchema = cloneDeep(shcema);
    processSchema.processName = processName;
    let useForm = getNotUseFormGroupPerProcess(processName);

    if (useForm) {

        processSchema.formGroups = null;

    }

    for (let column of processSchema.columns) {

        if (columnNameArray?.includes(column.name)) {

            column.hideInForm = false;

            if (useForm) {

                column.formGroup = 0;

            }

        } else {

            column.hideInForm = true;

        }

    }

    return processSchema
}

function getColumnNameArrayPerProcess(processName) { // 배열에 넣은 컬럼을 form에서 보여줍니다.

    switch (processName) {
        case "acquisistion":
            return ["consignee"];
        case "CAM":
            return ["num", "workTime", "workers", "isRepair"];
        case "Milling":
            return ["mlStHole", "mlAngleHole", "mlTap", "workTime", "workers", "isRepair", "size"];
        case "Grinding":
            return ["material", "grindingSideQty", "workTime", "isRepair", "size"];
        case "Nc":
            return ["num", "workTime", "works", "machineCode", "isRepair", "size"];
        case "Wire":
            return ["num", "machineCode", "workTime", "workers", "isRepair", "size"];
        case "ElectrodeProcessing":
            return ["size", "workers", "isRepair", "workTime", "epQty"];
        case "Edm":
            return ["num", "machineCode", "workTime", "workers", "isRepair", "size"];
        case "Wrapping":
            return ["wpShapeType", "wpProduct", "wpDivision", "wpArea", "wpInch", "wpSpec", "wpProductName", "workTime", "workers", "isRepair", "size"];
        case "Measurement":
            return ["tester", "testResultsDoc", "workTime"];
        default:
            return [];
    }
}

function getNotUseFormGroupPerProcess(processName) { // formGroup 사용 유무

    switch (processName) {
        case "Milling":
            return true;
        case "CAM":
            return true;
        default:
            return true;
    }
}

function getProcessName(processCode) {

    switch (processCode) {
        case "PR_START":
            return "acquisistion";

        case "PR_END":
            return "Measurement";

        case "PR002":
            return "Milling";

        case "PR003":
            return "Grinding";

        case "PR008":
        case "CAM":
            return "Nc";

        case "PR009":
            return "Wire";

        case "PR010":
            return "ElectrodeProcessing";

        case "PR011":
            return "Edm";

        case "PR012":
            return "Wrapping";

        default:
            return "";

    }

}

async function getNum(parentPlanId, processName) {

    let result = await getSpecific("TkVwPopProductManageDetail/num", parentPlanId, processName);

    return result.data[0]?.num ? result.data[0]?.num + 1 : 1;

}

export { settingHideProcessShcema, getProcessName, getColumnNameArrayPerProcess, getNum };